import { render, staticRenderFns } from "./ZvonoBotPreview.vue?vue&type=template&id=275f8de0&scoped=true"
import script from "./ZvonoBotPreview.vue?vue&type=script&lang=ts"
export * from "./ZvonoBotPreview.vue?vue&type=script&lang=ts"
import style0 from "./ZvonoBotPreview.vue?vue&type=style&index=0&id=275f8de0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f8de0",
  null
  
)

export default component.exports